import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { UserCheck, AlertCircle, Info } from 'lucide-react';
import { Link } from 'react-router-dom';

const IntelligentSpecialistRecommendation = ({ recommendation, onRequestSupport }) => {
  if (!recommendation || !recommendation.recommended) {
    return null;
  }

  // Always use soft, supportive styling (no urgency-based colors)
  const config = {
    bgClass: 'bg-gradient-to-r from-purple-50 to-indigo-50 border-purple-200',
    badgeClass: 'bg-purple-100 text-purple-700',
    icon: Info,
    iconBg: 'bg-purple-100',
    buttonClass: 'bg-purple-500 hover:bg-purple-600'
  };

  const Icon = config.icon;

  return (
    <Card className={`border-2 ${config.bgClass}`}>
      <CardContent className="p-5">
        <div className="flex items-start gap-4">
          <div className={`w-12 h-12 ${config.iconBg} rounded-full flex items-center justify-center flex-shrink-0`}>
            <UserCheck className="h-6 w-6 text-purple-600" />
          </div>
          
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-2 flex-wrap">
              <h4 className="font-bold text-gray-900 text-base">
                Get Extra Support (Optional)
              </h4>
            </div>
            
            <p className="text-sm text-gray-700 mb-3 leading-relaxed">
              {recommendation.message || "Based on your recent patterns, extra support could help you stay more consistent with your routine."}
            </p>
            
            {recommendation.reasons && recommendation.reasons.length > 0 && (
              <div className="mb-4 p-3 bg-white/90 rounded-lg border border-purple-200">
                <p className="text-xs font-semibold text-purple-900 mb-2 flex items-center gap-2">
                  <Icon className="h-4 w-4" />
                  What we noticed:
                </p>
                <ul className="space-y-1.5">
                  {recommendation.reasons.map((reason, index) => (
                    <li key={index} className="text-xs text-gray-700 flex items-start gap-2 leading-relaxed">
                      <span className="text-purple-400 flex-shrink-0 mt-0.5">•</span>
                      <span>{reason}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            
            <div className="flex flex-col sm:flex-row gap-2">
              <Link to="/expert-support" className="flex-1">
                <Button className={`w-full ${config.buttonClass} text-white`}>
                  <UserCheck className="h-4 w-4 mr-2" />
                  Get Expert Support
                </Button>
              </Link>
              {onRequestSupport && (
                <Button 
                  variant="outline" 
                  onClick={onRequestSupport}
                  className="flex-1 border-purple-300 text-purple-700 hover:bg-purple-50"
                >
                  Improve My Routine
                </Button>
              )}
            </div>
            
            <p className="text-xs text-gray-500 mt-3 text-center">
              💜 Support is optional and here whenever you need it
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default IntelligentSpecialistRecommendation;
